import { Card, CardBody, CardHead, EmptyState, Kpi, PageHead } from "@/components/common";
import { useAuth } from "@/auth/useAuth";
import { useActiveWorkspace } from "@/contexts/WorkspaceContext";
import { useMyWorkspaces } from "@/hooks/useWorkspaces";
import { useOrganizations } from "@/hooks/useOrganizations";
import { useClients } from "@/hooks/useClients";
import { formatBRL } from "@/utils/fmt";
import "./HomePage.css";

function greeting(): string {
  const h = new Date().getHours();
  if (h < 12) return "Bom dia";
  if (h < 18) return "Boa tarde";
  return "Boa noite";
}

export function HomePage() {
  const { user } = useAuth();
  const { activeWorkspaceId } = useActiveWorkspace();
  const { data: workspaces = [] } = useMyWorkspaces();
  const { data: orgs = [] } = useOrganizations(activeWorkspaceId);
  const { data: clients = [] } = useClients(activeWorkspaceId);

  const firstName = (user?.name ?? "").split(" ")[0] || "";
  const orgsAtivas = orgs.filter((o) => o.active).length;
  const empresasAtivas = clients.filter((c) => c.active).length;
  const totalMrr = workspaces.reduce((acc, w) => acc + Number(w.plan?.mrr_base ?? 0), 0);

  return (
    <>
      <PageHead
        title={`${greeting()}, ${firstName}.`}
        subtitle={`${orgs.length} organizações · ${clients.length} empresas no workspace ativo`}
      />

      <div className="kpi-grid">
        <Kpi
          icon="layers"
          tone="featured"
          label="Organizações"
          value={String(orgs.length)}
          sub={`${orgsAtivas} ativas`}
        />
        <Kpi
          icon="briefcase"
          label="Empresas"
          value={String(clients.length)}
          sub={`${empresasAtivas} ativas`}
        />
        <Kpi
          icon="building"
          label="Workspaces"
          value={String(workspaces.length)}
          sub="que você administra"
        />
        <Kpi icon="credit-card" label="MRR total" value={formatBRL(totalMrr)} sub="somatório dos planos" />
      </div>

      <div className="home-cols">
        <Card>
          <CardHead
            title="Crédito tributário consolidado"
            subtitle="Recuperação de créditos por tese"
          />
          <CardBody>
            <EmptyState
              icon="trending-up"
              title="Em breve"
              description="A estimativa de créditos recuperáveis chega com o módulo fiscal (teses, processos e apurações)."
            />
          </CardBody>
        </Card>
        <Card>
          <CardHead title="Alertas fiscais" subtitle="Itens que precisam de atenção" />
          <CardBody>
            <EmptyState
              icon="alert-triangle"
              title="Em breve"
              description="Obrigações, divergências e prazos aparecerão aqui quando a Operação for entregue."
            />
          </CardBody>
        </Card>
      </div>
    </>
  );
}
